<template>
    <div class="wa-status-modal">
        <SOSlotModal :modal-title="`Perangkat WA`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="f-16 f-regular f-c-black md-content" v-if="!isFetching">
                    <div class="wrapper-list">
                        <div class="d-flex-between-center" @click="selected({})">
                            <div>
                                <p class="m-d-0 f-16 f-semi f-c-black f-cont">
                                    Semua Perangkat
                                </p>
                            </div>
                            <div>
                                <RadioOption :is-checked="isSemuaPerangkat" />
                            </div>
                        </div>
                    </div>
                    <div
                        class="wrapper-list"
                        v-for="(list, idx) in listPerangkat.array"
                        :key="`d-wa-${idx}`"
                        :class="{ active: isActive(list.iddevice) }"
                    >
                        <div class="d-flex-between-center" @click="selected(list)">
                            <div>
                                <p class="m-d-0 f-16 f-semi f-c-black f-cont">
                                    {{ list.nama }}
                                </p>
                                <p class="m-d-0 f-14 f-regular f-c-midgrey">
                                    +{{ list.country_code }}{{ list.number }}
                                </p>
                            </div>
                            <div>
                                <IconBased width="16" height="16" v-if="isActive(list.iddevice)">
                                    <template v-slot:icons>
                                        <RadioCheckedBlue />
                                    </template>
                                </IconBased>
                                <IconBased width="16" height="16" v-else>
                                    <template v-slot:icons>
                                        <RadioUnChecked />
                                    </template>
                                </IconBased>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";

import RadioOption from "../RadioOption.vue";

import IconBased from "@/modules/wa-autosender/components/iconPack/IconBased.vue";
import RadioUnChecked from "@/modules/wa-autosender/components/iconPack/RadioUnChecked1616.vue";
import RadioCheckedBlue from "@/modules/wa-autosender/components/iconPack/RadioCheckedBlue1616.vue";

import { moduleName } from "../../store/state";

export default {
    name: "PilihPerangkat",
    components: {
        SOSlotModal,
        IconBased,
        RadioUnChecked,
        RadioCheckedBlue,
        RadioOption,
    },
    data() {
        return {
            backLink: "wa_status.list",
            modalId: "pilih-perangkat",
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    computed: {
        ...mapGetters(moduleName, {
            listPerangkat: "listPerangkat",
            dataDeviceTiny: "dataDeviceTiny",
            response: "response",
            isFetching: "isFetching",
        }),
        isActive() {
            return (deviceId) => {
                return this.dataDeviceTiny.iddevice === deviceId ? true : false;
            };
        },
        isSemuaPerangkat() {
            return this.dataDeviceTiny.iddevice === undefined;
        },
    },
    methods: {
        ...mapActions({
            getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
            resetDataDeviceTiny: `${moduleName}/resetDataDeviceTiny`,
        }),
        async back() {
            this.$router.go(-1);
        },
        setBackLink(val) {
            this.backLink = val;
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        async selected(val) {
            if (val.iddevice) {
                await this.getDetailTinyDevice({ deviceId: val.iddevice });
            } else {
                await this.resetDataDeviceTiny();
            }
            await this.back();
        },
    },
};
</script>
<style scoped>
.md-content {
    max-height: 50vh;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-left: -20px;
    margin-right: -20px;
}
.p-x-2 {
    padding-left: 2px;
    padding-right: 2px;
}
.wrapper-list {
    padding: 12px 20px;
}
.active {
    background-color: #edf5ff;
}
.cs-name {
    display: block;
}
</style>
